import React, {useMemo} from 'react';
import styled from "styled-components";
import {eventNameTrans, prevTierAndDivision, romanNumberTrans} from "../../function";
import EventPlayer from "./EventIcon";
import {FlexBox} from "../ui/styled";
import SmallInfluInfo from "../common/SmallInfluInfo";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 14px 10px;
`;
const EventPlayerList = ({data, room,}) => {
    return (
        <Wrapper>
            {data.map((item, index) => {
                return (
                    <PlayerCard key={item?.puu_id} tier={item?.tier} name={item?.name} live={false}
                                riot_tag={item?.riot_id_tag_line} riot_id={item?.riot_id_name} isRoom={false}
                                puuId={item?.puu_id} lp={item?.lp || 0} status={item?.status} pick={index + 1}
                                url_name={item?.status === 'Streamer' ? item.name : item?.url_name}
                                championship_name={item?.championship_name}
                    />)
            })}
            {/*<PlayerCard tier={'UNRANKED'} name={'ROOM'} lp={0} isRoom={true} live={room?.live}/>*/}
        </Wrapper>
    );
};


const CardWrapper = styled.div`
  position: relative;
  width: 208px;
  border: 1px solid ${props => props.theme.color.default_border_color};
  border-radius: 6px;
  background-color: ${props => props.theme.color.site_main_color};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0 20px 0;
`;

const NameText = styled.div`
  color: ${props => props.theme.color.dark_100};
  font-weight: bold;
  font-size: 20px;
  margin: 11px 0 10px 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  max-width: 10ch;
  line-height: 29px;
  text-transform: capitalize;

  &:hover {
    text-decoration: underline;
  }
`;

const TierBox = styled.div`
  width: 168px;
  padding: 8px;
  border-radius: 6px;
  background-color: ${props => props.theme.color.white_201};
`;

const DictWrapper = styled.div`
  width: 100%;
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  border-radius: 6px;
  text-transform: capitalize;

  &.challenger {
    background-color: #FFD940;
    color: #2660E6;
  }

  &.grandmaster {
    background-color: #EBB4C4;
    color: #B9354A;
  }

  &.master {
    background-color: #D3B3EA;
    color: #8D41A9;
  }

  &.diamond {
    background-color: #A7CDF2;
    color: #0063BB;
  }

  &.platinum {
    background-color: #97CBC4;
    color: #2A8492;
  }

  &.emerald {
    background-color: #7FD6A7;
    color: #21855A;
  }

  &.gold {
    background-color: #DBC798;
    color: #A17716;
  }

  &.silver {
    background-color: #B7BBCB;
    color: #626B8A;
  }

  &.bronze {
    background-color: #C0AA9B;
    color: #815639;
  }

  &.iron {
    background-color: #A7A097;
    color: #514330;
  }

  &.unranked {
    color: #7F7F7F;
    background-color: #D1D4DB;
  }
`;
const LPText = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-top: 5px;
  color: ${props => props.theme.color.dark_100};
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  line-height: 24px;
`;

const PickNumber = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  left: 10px;
  top: 10px;
  background-color: ${props => props.theme.color.green_200};
  color: ${props => props.theme.color.green_100};
`;
const PlayerCard = ({name, tier, lp, live, riot_id, riot_tag, puuId, isRoom, status, pick, url_name,championship_name}) => {

    const tierMeme = useMemo(() => {
        try {
            const splitTier = tier.split(' ');
            const division = romanNumberTrans(splitTier[1]);
            const tierItem = splitTier[0];
            return {tier: tierItem, division}
        } catch (e) {
            console.log(e)
            return {
                tier: 'UNRANKED',
                division: ""
            }
        }
    }, []);


    const onClickName = () => {
        window.open(`/${status === 'Streamer' ? 'strm' : 'pro'}/${url_name}`, "_blank", "noreferrer")
    }

    return (
        <CardWrapper>
            <PickNumber><span>{pick}</span></PickNumber>
            <PlayerCircle name={name} live={live} riot_tag={riot_tag} riot_id={riot_id} isRoom={isRoom} puuId={puuId}
                          status={status} url_name={url_name} championship_name={championship_name}/>
            <FlexBox alignItems={'center'}>
                <div>
                    <SmallInfluInfo status={status} height={20} width={20}/>
                </div>
                <NameText onClick={onClickName}>
                    {eventNameTrans(name)}
                </NameText>
            </FlexBox>
            <TierBox>
                <DictWrapper className={tierMeme.tier.toLowerCase()}>
                    {prevTierAndDivision(tierMeme.tier.toLowerCase(), tierMeme.division)}
                </DictWrapper>
                <LPText>
                    LP {lp}
                </LPText>
            </TierBox>
        </CardWrapper>
    )
}


////////////////////////
const Circle = styled.div`
  cursor: pointer;
  border-radius: 100%;
  border: 4px solid ${props => {
    let outline = 'transparent';
    if (props.live === 1) {
      outline = '#EB5B5B';
    }
    return outline
  }};
  box-shadow: ${props => {
    let shadow = '0';
    if (props.live === 1) {
      shadow = '0px 0px 10px 0px rgba(235, 91, 91, 80%)';
    }
    return shadow
  }};
  position: relative;
  display: flex;
  justify-content: center;
`;
const LiveAbsolute = styled.div`
  position: absolute;
  top: 90px;
`;

const PlayerCircle = ({name, live, isRoom, puuId, riot_id, riot_tag, status, url_name, championship_name}) => {
    return (
        <Circle live={live}>
            <EventPlayer name={status === 'pro' ? championship_name : name} width={100} height={100} isRoom={isRoom}
                         puuId={puuId} riot_id={riot_id}
                         riot_tag={riot_tag} status={status} url_name={url_name}/>
            {live === 1 &&
                <LiveAbsolute>
                    <img src={'images/event/event_live.svg'} width={42} height={20} alt={''}/>
                </LiveAbsolute>}
        </Circle>
    )
}

export default EventPlayerList;